import IconPaper from 'assets/Icon/IconPaper';
import { useTranslation } from 'react-i18next';
import IconNews from 'assets/Icon/IconNews';
import IconMenuTraining from 'assets/Icon/IconMenuTraining';
import IconMenuUser from 'assets/Icon/IconMenuUser';
import IconMarathonEvent from 'assets/Icon/IconMarathonEvent';
import IconHashtag from 'assets/Icon/IconHashtag';
import IconCandidatesMenu from 'assets/Icon/IconCandidatesMenu';
import IconBodInterviewManagement from 'assets/Icon/IconBodInterviewManagement';
import IconTestManagement from 'assets/Icon/IconTestManagement';

export const useMenuList = () => {
  const { t } = useTranslation();

  return [
    {
      label: 'Jobs Management',
      title: 'Jobs Management',
      path: '/job-management',
      key: '/job-management',
      icon: <IconPaper color="#666666" />
    },
    {
      label: 'Articles Management',
      title: 'Articles Management',
      path: '/articles-management',
      key: '/articles-management',
      icon: <IconNews color="#666666" />
    },
    {
      label: 'Candidates',
      title: 'Candidates',
      path: '/candidates-management',
      key: '/candidates-management',
      icon: <IconCandidatesMenu color="#666666" />
    },
    {
      label: 'User Management',
      title: 'User Management',
      path: '/user-management',
      key: '/user-management',
      icon: <IconMenuUser color="#666666" />
    },
    {
      label: 'Marathon Event',
      title: 'Marathon Event',
      path: '/marathon-event',
      key: '/marathon-event',
      icon: <IconMarathonEvent color="#666666" />
    },
    {
      label: 'Training Management',
      title: 'Training Management',
      path: '/training-management',
      key: '/training-management',
      icon: <IconMenuTraining color="#666666" />
    },
    {
      label: 'Hashtag Management',
      title: 'Hashtag Management',
      path: '/hashtag-management',
      key: '/hashtag-management',
      icon: <IconHashtag color="#666666" />
    },
    {
      label: 'Test management',
      title: 'Test management',
      path: '/test-management',
      key: '/test-management',
      icon: <IconTestManagement color="#666666" />
    },
    {
      label: 'BOD Interview Management',
      title: 'BOD Interview Management',
      path: '/bod-interview-management',
      key: '/bod-interview-management',
      icon: <IconBodInterviewManagement color="#666666" />
    }
  ];
};
